// Same rounding as the backend (bill_service._line_net / _apply_total_offers / _recompute_totals),
// so the cart preview matches the saved bill.

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export function formatMoney(n) {
  const num = Number(n) || 0;
  return `₹${num.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
}

/** 0–100, anything else becomes 0. */
export function offerPercent(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.min(100, n);
}

/** Keep only digits, max 100 — for the discount / voucher inputs. */
export function digitsOnlyPercent(raw) {
  const digits = String(raw ?? '').replace(/\D/g, '').slice(0, 3);
  if (!digits) return '';
  return String(Math.min(100, Number(digits)));
}

export function lineCharges(line) {
  const qty = Number(line?.quantity) || 1;
  const unit = Number(line?.unit_price) || 0;
  const gross = round2(qty * unit);
  const discountPct = offerPercent(line?.discount_percent);
  const voucherPct = offerPercent(line?.voucher_percent);
  const discount = round2((gross * discountPct) / 100);
  const voucher = round2((gross * voucherPct) / 100);
  const net = round2(Math.max(gross - discount - voucher, 0));
  return { gross, discount, voucher, net, discountPct, voucherPct };
}

export function cartTotals(lines, { taxRate = 0.18, totalDiscountPercent = 0, totalVoucherPercent = 0 } = {}) {
  let gross = 0;
  let lineOff = 0;
  let net = 0;
  (lines || []).forEach((line) => {
    const c = lineCharges(line);
    gross += c.gross;
    lineOff += c.discount + c.voucher;
    net += c.net;
  });
  net = round2(net);
  const billDiscount = round2((net * offerPercent(totalDiscountPercent)) / 100);
  const billVoucher = round2((net * offerPercent(totalVoucherPercent)) / 100);
  const offers = Math.min(round2(billDiscount + billVoucher), net);
  const taxable = Math.max(net - offers, 0);
  const tax = round2(taxable * (Number(taxRate) || 0));
  return {
    gross: round2(gross),
    lineOffers: round2(lineOff),
    billOffers: offers,
    subtotal: net,
    tax,
    grand: round2(taxable + tax),
  };
}

export function paidTotal(bill) {
  return round2(
    (bill?.payments || [])
      .filter((p) => ['received', 'verified'].includes(String(p.status).toLowerCase()))
      .reduce((sum, p) => sum + (Number(p.amount) || 0), 0),
  );
}

export function pendingAmount(bill) {
  return round2(Math.max((Number(bill?.grand_total) || 0) - paidTotal(bill), 0));
}
